import Vue from 'vue'
import App from './App.vue'
import 'vant/lib/index.css'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Clipboard from 'v-clipboard'

Vue.config.productionTip = false
Vue.use(Clipboard)
Vue.use(VueResource)
Vue.use(ElementUI)


new Vue({
  render: h => h(App),
}).$mount('#app')
